@let customerData = customer();

<dl>
  <dt>Firma:</dt>
  <dd>{{ customerData.name }}</dd>
  @for (phoneNumber of customerData.phoneNumbers; track phoneNumber) {
    <dt>Telefon:</dt>
    <dd>{{ phoneNumber }}</dd>
  }
</dl>

@if (customerData.tobacco) {
  <div class="tobacco-track-n-trace-box">
    <ui-icon faName="circle-check" faStyle="light"></ui-icon>
    <div class="box-text">
      <h2>Tabak Track & Trace ID</h2>
      <p>Diese Kundennummer ist für Tabak Track & Trace ID freigeschaltet.</p>
    </div>
  </div>
}

@if (customerData.emailAddresses && customerData.emailAddresses.length >= 1) {
  <div>
    <h2 class="h6">E-Mail-Adresse</h2>
    <dl>
      @for (emailAddress of customerData.emailAddresses; track emailAddress) {
        <dt>E-Mail-Adresse allgemein:</dt>
        <dd>{{ emailAddress }}</dd>
      }
    </dl>
  </div>
}

@if (customerData.invoiceRecipient; as recipient) {
  <div>
    <h2 class="h6">Rechnungsempfänger</h2>
    <dl>
      <dt>Kundennummer:</dt>
      <dd>{{ recipient.id }}</dd>
      <dt>Name:</dt>
      <dd>{{ recipient.name }}</dd>
      <dt>Straße:</dt>
      <dd>{{ recipient.address?.streetAddress }}</dd>
      <dt>PLZ:</dt>
      <dd>{{ recipient.address?.postalCode }}</dd>
      <dt>Ort:</dt>
      <dd>{{ recipient.address?.locality }}</dd>
    </dl>
  </div>
}

@if (customerData.deliveryRecipient; as recipient) {
  <div>
    <h2 class="h6">Warenempfänger</h2>
    <dl>
      <dt>Kundennummer:</dt>
      <dd>{{ recipient.id }}</dd>
      <dt>Name:</dt>
      <dd>{{ recipient.name }}</dd>
      <dt>Straße:</dt>
      <dd>{{ recipient.address?.streetAddress }}</dd>
      <dt>PLZ:</dt>
      <dd>{{ recipient.address?.postalCode }}</dd>
      <dt>Ort:</dt>
      <dd>{{ recipient.address?.locality }}</dd>
    </dl>
  </div>
}

@if (customerData.bank; as bankAccount) {
  <div>
    <h2 class="h6">Bankverbindung</h2>
    <dl>
      <dt>Name:</dt>
      <dd>{{ bankAccount.bank.name }}, {{ bankAccount.bank.locality }}</dd>
      <dt>IBAN:</dt>
      <dd>{{ bankAccount.iban }}</dd>
      <dt>BIC:</dt>
      <dd>{{ bankAccount.bank.bic }}</dd>
    </dl>
  </div>
}
